import { FC } from 'react'
import { Modal } from '@cargomart/ui'
import { MODAL_IDS } from 'components/ModalProvider'
import { OrderItem } from 'schema'
import { MultiAccordion } from 'src/components/MultiAccordion'
import { useIsLargeLaptop } from 'src/hooks'
import { paymentForm } from 'src/utils/feature'

import { useFindOrderPaymentQuery } from '../../api'
import { OrderPaymentSection } from '../OrderPaymentSection'
import { HELP_ITEMS } from './constants'
import OrderDetailRoutePoint from './OrderDetailRoutePoint'
import OrderYarcheAccepted from './OrderYarcheAccepted'
import OrderYarcheDetailDesktopHeader from './OrderYarcheDetailDesktopHeader'
import OrderYarcheDetailSummary from './OrderYarcheDetailSummary'
import OrderYarcheTracking from './OrderYarcheTracking'

interface OrderYarcheDetailDesktopProps {
  onClose: () => void
  order: OrderItem
}

const OrderYarcheDetailDesktop: FC<OrderYarcheDetailDesktopProps> = (props) => {
  const { order, onClose } = props

  const { data: payment, isLoading: isPaymentLoading } = useFindOrderPaymentQuery(order?.id ? order?.id : '', {
    skip: !order?.id
  })

  const isLargeLaptop = useIsLargeLaptop()

  return (
    <Modal
      isCloseOnEsc
      isCloseOnOutsideClick
      id={MODAL_IDS.OrderYarcheDetail}
      onClose={onClose}
      side="right"
      size={isLargeLaptop ? 'full' : 'xl'}
    >
      <OrderYarcheDetailDesktopHeader order={order} />
      <div className="grid grid-cols-1 gap-x-8 px-22 pt-4 md:gap-x-18 lg:grid-cols-[1.767fr_1fr]">
        <div className="mb-4 overflow-hidden">
          {order?.barcode && <OrderYarcheAccepted barcode={order.barcode} status={order.status} />}

          {order.status === OrderItem.Status.NEW && (
            <div className="mt-4">
              <MultiAccordion items={HELP_ITEMS} searchId="HELP_ITEMS" title="Помощь" />
            </div>
          )}

          {order?.barcode && order?.isCargoAccepted && (
            <OrderYarcheTracking barcode={order.barcode} className="mt-4 rounded-xl border border-outline p-4" />
          )}

          <OrderDetailRoutePoint
            className="mt-4 rounded-xl border border-outline p-4"
            contact={order.departure.partner.contact}
            mode="departurePoint"
            terminal={order.departure.point.terminal}
          />
          <OrderDetailRoutePoint
            className="mt-4 rounded-xl border border-outline p-4"
            contact={order.destination.partner.contact}
            mode="destinationPoint"
            terminal={order.destination.point.terminal}
          />
        </div>
        <OrderYarcheDetailSummary order={order} />
        <div className="pb-2">
          {paymentForm && (
            <OrderPaymentSection
              isDocumentInvoiceLoading={false}
              isFetching={false}
              isPaymentLoading={isPaymentLoading}
              order={order}
              payment={payment}
            />
          )}
        </div>
      </div>
    </Modal>
  )
}

export default OrderYarcheDetailDesktop
